import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
} from '@material-ui/core'
import { KeyboardArrowRight, MoreVert } from '@material-ui/icons'
import { DeleteDialog } from 'components/Dialog/DeleteDialog'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  useDeleteFaDepreciationMethodChangeMutation,
  useGetDocNumTitleQuery,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import React, { useContext, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory } from 'react-router'

export const DepreciationMethodEntryList = (props: any) => {
  const {
    filteredList,
    listLoading,
    listStatus,
    fetchMore,
    setOriginalListing,
  } = props
  const {
    handleClick,
    anchorEl,
    menu,
    handleClose,
    resetMenu,
  } = useMenuOption()
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const [deleteDialog, setDeleteDialog] = useState(false)
  const history = useHistory()
  const CompanyID = localStorage.getItem('latestCompany')
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: {
      CompanyID: CompanyID,
      RefTable: 'fa_asset_depreciation_method',
    },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const docNumChecker = getDocumentNumberHeader?.length === 0

  const [
    deleteDepreciationMethodChange,
    { loading: deleteLoading },
  ] = useDeleteFaDepreciationMethodChangeMutation({
    onError: ({ message }) => {
      const error = message?.substring(15)
      setErrMsg(error)
      setErrorDia(true)
      setDeleteDialog(false)
      resetMenu()
    },
    onCompleted: data => {
      if (data?.DeleteFADepreciationMethodChange) {
        setOpenSnackBar(true)
        setSnackBarMsg(SystemMsgs.deleteRecord())
        setDeleteDialog(false)
        setOriginalListing([])
        resetMenu()
        fetchMore({
          variables: {
            CompanyID: CompanyID,
            StatusArr: [listStatus],
            take: 30,
            skip: 0,
            searchValue:
              getSearch?.name === '' || getSearch?.name === undefined
                ? undefined
                : getSearch?.name,
          },
        })
      }
    },
  })

  const handleDelete = () => {
    if (menu?.obj?.depreciation_method_change_id) {
      deleteDepreciationMethodChange({
        variables: {
          depreciation_method_change_id: menu.obj.depreciation_method_change_id,
        },
      })
    }
  }
  const { handlePermDisabled } = usePermissionChecker()

  return (
    <>
      {listLoading && <Loading />}
      {deleteLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      <ContentWrapper advSearch float>
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList).length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: listStatus,
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name === '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                  },
                })
              }}
              hasMore={true}
              className=""
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)
                ?.sort((a, b) => {
                  return (
                    Object.values(ApprovalStatus).indexOf(a?.ApprovalStatus) -
                    Object.values(ApprovalStatus).indexOf(b?.ApprovalStatus)
                  )
                })
                ?.map((el, index) => {
                  return (
                    <ListItem key={index}>
                      <ListItemText
                        primary={
                          <>
                            <span className="desc date-width">
                              {`${formatDate(el?.change_date)}` || 'N/A'}
                            </span>
                            <span className="xsTitle flex-space">
                              {el?.DocNo}
                            </span>
                            <span className={`xsTitle`}>{el?.Asset?.name}</span>
                          </>
                        }
                        secondary={
                          <>
                            <Grid container spacing={0}>
                              <Grid container className="table-content">
                                <Grid item xs={6}>
                                  <span className="desc flex-space">
                                    {el?.Asset?.Category?.name}
                                  </span>
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  style={{ textAlign: 'right' }}
                                >
                                  <span className="desc">
                                    {el?.NewDepreciationMethod?.name}
                                  </span>
                                </Grid>
                              </Grid>
                              <Grid container>
                                <Grid item xs={12}>
                                  <span className="desc">{el?.reason}</span>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        }
                      />

                      <ListItemSecondaryAction>
                        {listStatus === 'ACTIVE' ||
                        listStatus === 'REJECTED' ? (
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            aria-controls="menu-list"
                            aria-haspopup="true"
                            onClick={e =>
                              handleClick(
                                e,
                                el?.depreciation_method_change_id,
                                index,
                                el
                              )
                            }
                          >
                            <MoreVert />
                          </IconButton>
                        ) : (
                          <IconButton edge="end" aria-label="arrow">
                            <KeyboardArrowRight
                              onClick={() =>
                                history.push({
                                  pathname: `/fixed-assets/${CompanyID}/assets-change/depreciation-method/detail`,
                                  state: el,
                                })
                              }
                            />
                          </IconButton>
                        )}
                      </ListItemSecondaryAction>
                    </ListItem>
                  )
                })}
            </InfiniteScroll>
          )}
        </List>
        {listStatus === 'ACTIVE' && (
          <FloatButton
            onClick={() => {
              if (docNumChecker) {
                setOpenSnackBar(true)
                setSnackBarMsg(SystemMsgs.errorNumberingStructure())
              } else {
                history.push(
                  `/fixed-assets/${CompanyID}/assets-change/depreciation-method/add`
                )
              }
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsDepreciationMethodCreate,
            })}
          />
        )}
      </ContentWrapper>

      {listStatus === 'ACTIVE' ? (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-change/depreciation-method/edit`,
                state: menu?.obj,
              })
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsDepreciationMethodUpdate,
            })}
          >
            <span className="">Edit</span>
          </MenuItem>
          <MenuItem
            onClick={() => setDeleteDialog(true)}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsDepreciationMethodDelete,
            })}
          >
            <span>Delete</span>
          </MenuItem>
        </Menu>
      ) : (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            onClick={() => {
              history.push({
                pathname: `/fixed-assets/${CompanyID}/assets-change/depreciation-method/resubmit`,
                state: { ...menu?.obj, mode: 'resubmit' },
              })
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.FixedAssetsDepreciationMethodUpdate,
            })}
          >
            <span className="">Resubmit</span>
          </MenuItem>
        </Menu>
      )}

      <DeleteDialog
        ID={menu?.ID}
        openDeleteDialog={deleteDialog}
        setOpenDeleteDialog={setDeleteDialog}
        title={'Depreciation Method Change'}
        menu={menu?.obj}
        handleDelete={handleDelete}
        passID={menu?.ID}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error'}
      />
    </>
  )
}
